/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MachineScheduleViewModel } from '../../models/machine-schedule-view-model';

export interface GetAll$Params {
  workCenterId: number;
  PageIndex?: number | null;
  PageSize?: number | null;
}

export function getAll(http: HttpClient, rootUrl: string, params: GetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MachineScheduleViewModel>>> {
  const rb = new RequestBuilder(rootUrl, getAll.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
    rb.query('PageIndex', params.PageIndex, {});
    rb.query('PageSize', params.PageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MachineScheduleViewModel>>;
    })
  );
}

getAll.PATH = '/api/v1/MachineSchedule/{workCenterId}/ShowAll';
